export const FETCH_ATTRIBUTES = 'organizations/users/attributes/FETCH'
export const FETCH_ATTRIBUTES_SUCCESS = `${FETCH_ATTRIBUTES}_SUCCESS`

export const FETCH_ATTRIBUTE = 'organizations/users/attributes/FETCH_BY_ID'
export const FETCH_ATTRIBUTE_SUCCESS = `${FETCH_ATTRIBUTE}_SUCCESS`

export const DELETE_ATTRIBUTE = 'organizations/users/attributes/DELETE'
export const DELETE_ATTRIBUTE_SUCCESS = `${DELETE_ATTRIBUTE}_SUCCESS`
